import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import BillsAccountsContainer from '../../containers/bills-accounts-statics/BillsAccountsContainer';

const BillsAccountsPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="결산 관리/계산서별 실적" icon="statistics" />
      <BillsAccountsContainer />
    </>
  );
};

export default BillsAccountsPage;
